import { render } from "./AddErgo.vue?vue&type=template&id=e6c012b2"
import script from "./AddErgo.vue?vue&type=script&lang=js"
export * from "./AddErgo.vue?vue&type=script&lang=js"
script.render = render

export default script